import { styled, alpha } from '@mui/material/styles';
import { Button, Tabs, Tab } from '@mui/material';

export const DataSourceCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isConnected' && prop !== 'isPremium'
})(({ isPremium }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  border: isPremium
    ? (theme) => `1px solid ${theme.palette.secondary.main}80`
    : '1px solid rgba(0, 0, 0, 0.1)',
  transition: 'all 0.2s ease',
  position: 'relative',

  '&:hover': {
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
    transform: 'translateY(-2px)',
    backgroundColor: (theme) => theme.palette.secondary.light,
  },
}));

export const PageContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
}));

export const PremiumBadge = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  backgroundColor: theme.palette.secondary.main,
  color: '#fff',
  padding: '4px 8px',
  borderRadius: '4px',
  fontSize: '0.7rem',
  fontWeight: 500,
}));

export const DataSourceIcon = styled('div')(({ theme }) => ({
  width: '60px',
  height: '60px',
  backgroundColor: alpha(theme.palette.secondary.dark, 0.05),
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '15px',
}));

export const DataSourceName = styled('h3')({
  fontSize: '1.2rem',
  margin: '0 0 5px 0',
});

export const DataSourceDescription = styled('p')({
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '0.9rem',
  margin: '0 0 15px 0',
  flex: 1,
});

export const DataSourceFooter = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '15px',
});

export const ConnectionStatus = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isConnected'
})(({ isConnected }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.8rem',
  color: isConnected ? '#4CAF50' : 'rgba(0, 0, 0, 0.4)',
}));

export const StatusDot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isConnected'
})(({ isConnected }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: isConnected ? '#4CAF50' : 'rgba(0, 0, 0, 0.2)',
  marginRight: '6px',
}));

export const SearchFilterSection = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
  gap: '20px',
  flexWrap: 'wrap',
});

export const SearchBar = styled('div')({
  flexGrow: 1,
  maxWidth: '500px',
});

export const Filters = styled('div')({
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
  flexWrap: 'wrap',
});

export const ModalOverlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
});

export const ModalContainer = styled('div')({
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px',
  width: '90%',
  maxWidth: '500px',
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
});

export const ModalHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
});

export const ModalTitle = styled('h2')({
  margin: 0,
  fontSize: '1.5rem',
});

export const ModalCloseButton = styled(Button)({
  minWidth: 'unset',
  padding: '5px',
});

export const FormField = styled('div')({
  marginBottom: '20px',
});

export const FormLabel = styled('label')({
  display: 'block',
  marginBottom: '5px',
  fontSize: '0.9rem',
  fontWeight: 500,
});

export const FormActions = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
  marginTop: '30px',
});

export const Container = styled('div')({
  padding: '30px',
  maxWidth: '1200px',
  margin: '0 auto',
});

export const SectionTitle = styled('h1')({
  fontSize: '1.8rem',
  marginBottom: '0.5rem',
  fontWeight: 500,
  color: '#333',
});

export const DataSourcesGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: '20px',
  marginTop: '20px',
});

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 80,
  marginRight: theme.spacing(2),
  '&.Mui-selected': {
      color: theme.palette.secondary.main,
      fontWeight: 500,
  },
}));